import { useMemo } from 'react'
import { useBreakpoint } from '@mtsbank/ui-kit'
import { useCyberStore } from '@entities/tsp'
import { CountryWithIconAndTooltip } from '@entities/country'
import { useTheme } from '@shared/lib'
import { getCountriesSteam } from '@entities/country/lib/getCountriesSteam'

interface useCountryListArgs {
  isSteam: boolean
  showVouchersForm: boolean
  countryVouchers: CountryWithIconAndTooltip[]
  handleCISCountryListModalSwitch?: (e: any) => void
}

export const useCountryList = ({
  isSteam,
  showVouchersForm,
  countryVouchers,
  handleCISCountryListModalSwitch,
}: useCountryListArgs) => {
  const theme = useTheme()

  const { isMobile } = useBreakpoint()

  const { activeCountrySteam } = useCyberStore()

  const countryList = useMemo(() => {
    if (isSteam && !showVouchersForm) {
      const isActive = activeCountrySteam === 'Страны СНГ'

      return getCountriesSteam(isMobile, activeCountrySteam, theme, isActive, handleCISCountryListModalSwitch)
    }

    return countryVouchers
  }, [activeCountrySteam, isMobile, countryVouchers, isSteam, showVouchersForm])

  return { countryList }
}
